module.exports = __webpack_public_path__ + "img/no-data.a7e9bac3.png";